//#region 우클릭 메뉴 한글화 작업

export const SnGridLocaleText = {
  sortAscending: "오름차순 정렬",
  sortDescending: "내림차순 정렬",

  // 컬럼 크기 조정
  autosizeThisColumn: "이 열 크기 자동 조정",
  autosizeAllColumns: "모든 열 크기 자동 조정",

  // 컬럼 선택
  pivotMode: "피벗 모드",

  toolPanelColumns: "컬럼 선택",
  chooseColumns: "항목 복원",
  columnChooser: "항목 복원",

  // 초기화
  resetColumns: "열 초기화",

  // 기타 기본 키
  pinColumn: "컬럼 고정",

  // 컬럼 고정 메뉴
  pinLeft: "왼쪽에 고정", // Pin Left
  pinRight: "오른쪽에 고정", // Pin Right
  noPin: "고정 해제", // No Pin

  csvExport: "CSV 내보내기", // CSV Export
  excelExport: "Excel 내보내기", // Excel Export

  copy: "복사",
  copyWithHeaders: "헤더 포함 복사",
  copyWithGroupHeaders: "그룹 헤더 포함 복사",
  paste: "붙여넣기",
  export: "내보내기",
  filterOoo: "필터...",
  equals: "같음",
  notEqual: "같지 않음",
  lessThan: "미만",
  greaterThan: "초과",
  inRange: "범위 내",
  groupBy: "그룹화",
  ungroupAll: "모든 그룹 해제",
  expandAll: "전체 확장",
  collapseAll: "전체 축소",
  autoSizeThis: "이 열 크기 자동 조정",
  chartRange: "차트 범위",
  categories: "범주",
  series: "시리즈",
  chartSettings: "차트 설정",
  chartType: "차트 유형",
  legend: "범례",
  axisLabels: "축 레이블",
  valueAxis: "값 축",
  categoryAxis: "범주 축",
  exportChart: "차트 내보내기",

  // 추가 번역 항목
  resetChart: "차트 초기화",
  groupedColumn: "그룹화된 열",
  stackedColumn: "스택 열",
  normalizedColumn: "정규화된 열",
  groupedBar: "그룹화된 막대",
  stackedBar: "스택 막대",
  normalizedBar: "정규화된 막대",
  pie: "원형 차트",
  doughnut: "도넛 차트",
  line: "선형 차트",
  scatter: "산점도",
  bubble: "버블 차트",
  area: "영역 차트",
  stackedArea: "스택 영역",
  normalizedArea: "정규화된 영역",
  columnChart: "열 차트",

  barChart: "막대 차트",

  pieChart: "원형 차트",

  lineChart: "선형 차트",
  xyChart: "X Y (산점도)",

  areaChart: "영역 차트",

  histogramChart: "히스토그램",
  rangeBarChart: "범위 막대",
  rangeAreaChart: "범위 영역",
  combinationChart: "조합 차트",

  polarChart: "극좌표 차트",
  radarLine: "방사형 선형 차트",
  radarArea: "방사형 영역 차트",
  nightingale: "나이팅게일 차트",
  radialColumn: "방사형 열 차트",
  radialBar: "방사형 막대 차트",

  statisticalChart: "통계 차트",
  boxPlot: "상자 그림",
  histogram: "히스토그램",
  rangeBar: "범위 막대",
  rangeArea: "범위 영역",

  hierarchicalChart: "계층형 차트",
  organizationChart: "조직도 차트",
  treeChart: "트리 차트",

  specializedChart: "특수 차트",
  heatMap: "히트맵",
  treemap: "트리맵",
  waterfall: "폭포 차트",

  // 조합 차트
  columnLineCombo: "열 & 선형 차트", // Column & Line
  areaColumnCombo: "영역 & 열 차트", // Area & Column

  // 계층형 차트
  sunburst: "선버스트", // Sunburst

  // 특수 차트
  heatmap: "히트맵",
} as const;

//#endregion
// Default Grid Options
export const SnGridDefaultOptions = {
  defaultColDef: {
    sortable: true,
    filter: "agTextColumnFilter",
    floatingFilter: false,
    resizable: true,
    suppressMenu: true,
    enableRowGroup: true,
    headerClass: "header-center",
  },
  pagination: false,
  paginationPageSize: 50,
  paginationPageSizeSelector: [50, 100],
  enableRangeSelection: true,
  animateRows: true,
  rowDragManaged: false,
  cellSelection: true,
  suppressNoRowsOverlay: true,
  suppressMenuHide: false,
  rowGroupPanelShow: "onlyWhenGrouping",
};
